import { Box, Text } from "grommet";
import React from "react";

const TableauCellFormat = (props:any) => {
    let inputValue = props.cell.toString();
    // console.log(inputValue)
    let iv = inputValue.split(";");
    // remove length is 0 in iv
    let cell_list = iv.map((v: any) => {
        if (v.length > 0) {
            return v;
        }
    });
    const TextReplace = (text: string) => {
        let replace_text = [
            ["兼務者", "兼"],
            ["朝鮮人", "鮮"],
            ["鮮人", "鮮"],
            ["內地人", "內"],
            ["支那人", "支那"],
            ["合하女", "합하여"],
            ["男원군", "남원군"],
        ];
        for (let i = 0; i < replace_text.length; i++) {
            text = text.replace(replace_text[i][0], replace_text[i][1]);
        }
        return text;
    };

    const TextFormat = (props: any) => {
        let cellValue = props.cellunit;
        if (cellValue === undefined) {
            cellValue = "";
        }
        let cv = cellValue.split(":");
        if (cv.length === 1) {
            let cv_1 = cv[0];
            if (cv_1[0] === "(") {
                let cv_1div = cv_1.split(")");
                cv = [cv_1div[0].replace("(", ""), cv_1div[1]];
            }
        }
        let info_ko = "";
        if (cellValue.split("|").length > 1) {
            info_ko = cellValue.split("|")[1];
        }
        return (
            <Box direction="column">
                {cv.length > 1 ? (
                    cv[0].length < 10 ? (
                        <Box direction="row" align="center" justify="end">
                            <CellPrefix value={TextReplace(cv[0])} />
                            {info_ko.length > 0 ? (
                                <CellWithKo value={cv[1]} />
                            ) : (
                                <CellNormal value={cv[1]} />
                            )}
                        </Box>
                    ) : (
                        <Box direction="column" align="center" justify="end">
                            <CellPrefix value={TextReplace(cv[0])} />
                            {info_ko.length > 0 ? (
                                <CellWithKo value={cv[1]} />
                            ) : (
                                <CellNormal value={cv[1]} />
                            )}
                        </Box>
                    )
                ) : (
                    <Box align="end" justify="end">
                        {info_ko.length > 0 ? (
                            <CellWithKo value={cv[0]} />
                        ) : (
                            <CellNormal value={cv[0]} />
                        )}
                    </Box>
                )}
            </Box>
        );
    };
    const CellWithKo = (props: any) => {
        let inputValue = props.value;
        let value_div = inputValue.split("|");
        let info_ko = value_div[1];
        inputValue = value_div[0];

        return (
            <Box align="end" justify="end" direction="column">
                <Text size="12px">{inputValue}</Text>
                <Text size="9px" color="grey">
                    {info_ko}
                </Text>
            </Box>
        );
    };
    const CellNormal = (props: any) => {
        let inputValue = props.value;
        return (
            <Box align="end" justify="end" direction="column">
                <Text size="12px">{inputValue}</Text>
            </Box>
        );
    };
    const CellPrefix = (props: any) => {
        let inputValue = props.value;
        return (
            <Text size="10px" color="grey" margin={{ right: "2px" }}>
                {inputValue}
            </Text>
        );
    };
    return (
        <Box direction="column">
            {cell_list.map((v: any) => (
                <Box direction="column" key={v}>
                    <TextFormat cellunit={v} />
                </Box>
            ))}
        </Box>
    );
};

export default TableauCellFormat;
